import React from "react";
import { Stack } from "@mui/material";
import EstructuraGuiaPanel from "./EstructuraGuiaPanel";
import GuiaReferenciaPanel from "./GuiaReferenciaPanel";

const PanelLateralCrearMensajes = ({ sx }) => (
  <Stack spacing={2} sx={sx}>
    <EstructuraGuiaPanel />
    <GuiaReferenciaPanel />
  </Stack>
);

export default PanelLateralCrearMensajes;
